


// import {
//   REGISTER_SUCCESS,
//   REGISTER_FAIL,
//   LOGIN_SUCCESS,
//   LOGIN_FAIL,
//   LOGOUT,
//   SET_MESSAGE,
//   UPDATE_PROFILE_REQUEST,
//   UPDATE_PROFILE_SUCCESS,
//   UPDATE_PROFILE_FAIL,
//   UPLOAD_IMAGE_REQUEST,
//   UPLOAD_IMAGE_SUCCESS,
//   UPLOAD_IMAGE_FAIL,
//   // NOUVEAUX TYPES POUR GET_PROFILE
//   GET_PROFILE_REQUEST,
//   GET_PROFILE_SUCCESS,
//   GET_PROFILE_FAIL,
// } from "./types";

// import AuthService from "../services/auth.service";

// // Fonction de validation du mot de passe
// const validatePassword = (password) => {
//   const criteria = {
//     length: password.length >= 8,
//     uppercase: /[A-Z]/.test(password),
//     lowercase: /[a-z]/.test(password),
//     number: /\d/.test(password),
//     special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
//   };

//   const validCriteria = Object.values(criteria).filter(Boolean).length;
  
//   if (validCriteria < 4) {
//     let missingCriteria = [];
//     if (!criteria.length) missingCriteria.push("au moins 8 caractères");
//     if (!criteria.uppercase) missingCriteria.push("une lettre majuscule");
//     if (!criteria.lowercase) missingCriteria.push("une lettre minuscule");
//     if (!criteria.number) missingCriteria.push("un chiffre");
//     if (!criteria.special) missingCriteria.push("un caractère spécial");
    
//     return {
//       isValid: false,
//       message: `Le mot de passe doit contenir : ${missingCriteria.join(", ")}.`
//     };
//   }

//   return {
//     isValid: true,
//     message: "Mot de passe valide"
//   };
// };

// // Action register (inchangée)
// export const register = (username, email, password, confirmPassword, acceptTerms, acceptPrivacy) => (dispatch) => {
//   if (password !== confirmPassword) {
//     dispatch({
//       type: REGISTER_FAIL,
//     });
//     dispatch({
//       type: SET_MESSAGE,
//       payload: "Les mots de passe ne correspondent pas.",
//     });
//     return Promise.reject();
//   }

//   if (!acceptTerms) {
//     dispatch({
//       type: REGISTER_FAIL,
//     });
//     dispatch({
//       type: SET_MESSAGE,
//       payload: "Vous devez accepter les conditions d'utilisation.",
//     });
//     return Promise.reject();
//   }

//   if (!acceptPrivacy) {
//     dispatch({
//       type: REGISTER_FAIL,
//     });
//     dispatch({
//       type: SET_MESSAGE,
//       payload: "Vous devez accepter la politique de confidentialité.",
//     });
//     return Promise.reject();
//   }

//   const passwordValidation = validatePassword(password);
//   if (!passwordValidation.isValid) {
//     dispatch({
//       type: REGISTER_FAIL,
//     });
//     dispatch({
//       type: SET_MESSAGE,
//       payload: passwordValidation.message,
//     });
//     return Promise.reject();
//   }

//   return AuthService.register(
//     username, 
//     email, 
//     password, 
//     confirmPassword,
//     acceptTerms,
//     acceptPrivacy
//   ).then(
//     (response) => {
//       dispatch({
//         type: REGISTER_SUCCESS,
//       });

//       dispatch({
//         type: SET_MESSAGE,
//         payload: response.data.message,
//       });

//       return Promise.resolve();
//     },
//     (error) => {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();

//       dispatch({
//         type: REGISTER_FAIL,
//       });

//       dispatch({
//         type: SET_MESSAGE,
//         payload: message,
//       });

//       return Promise.reject();
//     }
//   );
// };

// // Action login (inchangée)
// export const login = (username, password) => (dispatch) => {
//   return AuthService.login(username, password).then(
//     (data) => {
//       dispatch({
//         type: LOGIN_SUCCESS,
//         payload: { user: data },
//       });

//       return Promise.resolve();
//     },
//     (error) => {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();

//       dispatch({
//         type: LOGIN_FAIL,
//       });

//       dispatch({
//         type: SET_MESSAGE,
//         payload: message,
//       });

//       return Promise.reject();
//     }
//   );
// };

// // Action logout (inchangée)
// export const logout = () => (dispatch) => {
//   AuthService.logout();

//   dispatch({
//     type: LOGOUT,
//   });
// };

// // Action pour vérifier la force du mot de passe (inchangée)
// export const checkPasswordStrength = (password) => {
//   return validatePassword(password);
// };

// // ✅ NOUVELLE ACTION POUR RÉCUPÉRER LE PROFIL
// export const getProfile = () => (dispatch) => {
//   dispatch({
//     type: GET_PROFILE_REQUEST,
//   });

//   return AuthService.getProfile().then(
//     (response) => {
//       dispatch({
//         type: GET_PROFILE_SUCCESS,
//         payload: response,
//       });

//       // Mettre à jour le localStorage avec les données complètes
//       const user = JSON.parse(localStorage.getItem("user"));
//       if (user) {
//         const updatedUser = { ...user, ...response };
//         localStorage.setItem("user", JSON.stringify(updatedUser));
//       }

//       return Promise.resolve(response);
//     },
//     (error) => {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();

//       dispatch({
//         type: GET_PROFILE_FAIL,
//       });

//       dispatch({
//         type: SET_MESSAGE,
//         payload: message,
//       });

//       return Promise.reject(error);
//     }
//   );
// };

// // Action pour mettre à jour le profil (inchangée)
// export const updateProfile = (profileData) => (dispatch) => {
//   dispatch({
//     type: UPDATE_PROFILE_REQUEST,
//   });

//   return AuthService.updateProfile(profileData).then(
//     (response) => {
//       dispatch({
//         type: UPDATE_PROFILE_SUCCESS,
//         payload: response,
//       });

//       // Mettre à jour le localStorage
//       const user = JSON.parse(localStorage.getItem("user"));
//       if (user) {
//         const updatedUser = { ...user, ...response };
//         localStorage.setItem("user", JSON.stringify(updatedUser));
//       }

//       dispatch({
//         type: SET_MESSAGE,
//         payload: "Profil mis à jour avec succès !",
//       });

//       return Promise.resolve(response);
//     },
//     (error) => {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();

//       dispatch({
//         type: UPDATE_PROFILE_FAIL,
//       });

//       dispatch({
//         type: SET_MESSAGE,
//         payload: message,
//       });

//       return Promise.reject(error);
//     }
//   );
// };

// export const updateEmail = (newEmail, password) => (dispatch) => {
//     return AuthService.updateEmail(newEmail, password).then(
//         (response) => {
//             // Mettre à jour le localStorage
//             const user = JSON.parse(localStorage.getItem("user"));
//             if (user) {
//                 const updatedUser = { ...user, email: newEmail };
//                 localStorage.setItem("user", JSON.stringify(updatedUser));
//             }
//             return Promise.resolve(response);
//         },
//         (error) => {
//             const message = error.response?.data?.message || error.message;
//             dispatch({ type: SET_MESSAGE, payload: message });
//             return Promise.reject(error);
//         }
//     );
// };

// // Action pour uploader une image (inchangée)
// export const uploadProfileImage = (imageData) => (dispatch) => {
//   dispatch({
//     type: UPLOAD_IMAGE_REQUEST,
//   });

//   return AuthService.uploadProfileImage(imageData).then(
//     (response) => {
//       dispatch({
//         type: UPLOAD_IMAGE_SUCCESS,
//         payload: response,
//       });

//       // Mettre à jour le localStorage
//       const user = JSON.parse(localStorage.getItem("user"));
//       if (user) {
//         const updatedUser = { 
//           ...user, 
//           profileImage: response.imageUrl || response.profileImage 
//         };
//         localStorage.setItem("user", JSON.stringify(updatedUser));
//       }

//       dispatch({
//         type: SET_MESSAGE,
//         payload: "Image uploadée avec succès !",
//       });

//       return Promise.resolve(response);
//     },
//     (error) => {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();

//       dispatch({
//         type: UPLOAD_IMAGE_FAIL,
//       });

//       dispatch({
//         type: SET_MESSAGE,
//         payload: message,
//       });

//       return Promise.reject(error);
//     }
//   );
// };


import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAIL,
  UPLOAD_IMAGE_REQUEST,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAIL,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL,
} from "./types";

import AuthService from "../services/auth.service";

// Fonction de validation du mot de passe
const validatePassword = (password) => {
  const criteria = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
  };

  const validCriteria = Object.values(criteria).filter(Boolean).length;

  if (validCriteria < 4) {
    let missingCriteria = [];
    if (!criteria.length) missingCriteria.push("au moins 8 caractères");
    if (!criteria.uppercase) missingCriteria.push("une lettre majuscule");
    if (!criteria.lowercase) missingCriteria.push("une lettre minuscule");
    if (!criteria.number) missingCriteria.push("un chiffre");
    if (!criteria.special) missingCriteria.push("un caractère spécial");

    return {
      isValid: false,
      message: `Le mot de passe doit contenir : ${missingCriteria.join(", ")}.`
    };
  }

  return {
    isValid: true,
    message: "Mot de passe valide"
  };
};

// ✅ MODIFIÉ : Action register avec fullName en paramètre (optionnel)
//    Rétro-compatible : si on ne passe pas fullName, ça continue de fonctionner
export const register = (username, email, password, confirmPassword, acceptTerms, acceptPrivacy, fullName) => (dispatch) => {
  if (password !== confirmPassword) {
    dispatch({
      type: REGISTER_FAIL,
    });
    dispatch({
      type: SET_MESSAGE,
      payload: "Les mots de passe ne correspondent pas.",
    });
    return Promise.reject();
  }

  if (!acceptTerms) {
    dispatch({
      type: REGISTER_FAIL,
    });
    dispatch({
      type: SET_MESSAGE,
      payload: "Vous devez accepter les conditions d'utilisation.",
    });
    return Promise.reject();
  }

  if (!acceptPrivacy) {
    dispatch({
      type: REGISTER_FAIL,
    });
    dispatch({
      type: SET_MESSAGE,
      payload: "Vous devez accepter la politique de confidentialité.",
    });
    return Promise.reject();
  }

  const passwordValidation = validatePassword(password);
  if (!passwordValidation.isValid) {
    dispatch({
      type: REGISTER_FAIL,
    });
    dispatch({
      type: SET_MESSAGE,
      payload: passwordValidation.message,
    });
    return Promise.reject();
  }

  // ✅ NOUVEAU : passer fullName au service
  return AuthService.register(
    username,
    email,
    password,
    confirmPassword,
    acceptTerms,
    acceptPrivacy,
    fullName  // ← AJOUT
  ).then(
    (response) => {
      dispatch({
        type: REGISTER_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: REGISTER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

// Action login (inchangée)
export const login = (username, password) => (dispatch) => {
  return AuthService.login(username, password).then(
    (data) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

// Action logout (inchangée)
export const logout = () => (dispatch) => {
  AuthService.logout();

  dispatch({
    type: LOGOUT,
  });
};

// Action pour vérifier la force du mot de passe (inchangée)
export const checkPasswordStrength = (password) => {
  return validatePassword(password);
};

// Action pour récupérer le profil (inchangée)
export const getProfile = () => (dispatch) => {
  dispatch({
    type: GET_PROFILE_REQUEST,
  });

  return AuthService.getProfile().then(
    (response) => {
      dispatch({
        type: GET_PROFILE_SUCCESS,
        payload: response,
      });

      // Mettre à jour le localStorage avec les données complètes
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        const updatedUser = { ...user, ...response };
        localStorage.setItem("user", JSON.stringify(updatedUser));
      }

      return Promise.resolve(response);
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: GET_PROFILE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

// Action pour mettre à jour le profil (inchangée)
export const updateProfile = (profileData) => (dispatch) => {
  dispatch({
    type: UPDATE_PROFILE_REQUEST,
  });

  return AuthService.updateProfile(profileData).then(
    (response) => {
      dispatch({
        type: UPDATE_PROFILE_SUCCESS,
        payload: response,
      });

      // Mettre à jour le localStorage
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        const updatedUser = { ...user, ...response };
        localStorage.setItem("user", JSON.stringify(updatedUser));
      }

      dispatch({
        type: SET_MESSAGE,
        payload: "Profil mis à jour avec succès !",
      });

      return Promise.resolve(response);
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: UPDATE_PROFILE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

export const updateEmail = (newEmail, password) => (dispatch) => {
  return AuthService.updateEmail(newEmail, password).then(
    (response) => {
      // Mettre à jour le localStorage
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        const updatedUser = { ...user, email: newEmail };
        localStorage.setItem("user", JSON.stringify(updatedUser));
      }
      return Promise.resolve(response);
    },
    (error) => {
      const message = error.response?.data?.message || error.message;
      dispatch({ type: SET_MESSAGE, payload: message });
      return Promise.reject(error);
    }
  );
};

// Action pour uploader une image (inchangée)
export const uploadProfileImage = (imageData) => (dispatch) => {
  dispatch({
    type: UPLOAD_IMAGE_REQUEST,
  });

  return AuthService.uploadProfileImage(imageData).then(
    (response) => {
      dispatch({
        type: UPLOAD_IMAGE_SUCCESS,
        payload: response,
      });

      // Mettre à jour le localStorage
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        const updatedUser = {
          ...user,
          profileImage: response.imageUrl || response.profileImage
        };
        localStorage.setItem("user", JSON.stringify(updatedUser));
      }

      dispatch({
        type: SET_MESSAGE,
        payload: "Image uploadée avec succès !",
      });

      return Promise.resolve(response);
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: UPLOAD_IMAGE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

